import { Router } from '@angular/router';
import { Component, OnInit, NgZone, Output,EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
// import { LocationService } from 'src/app/modules/shared/services/location.service';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import * as _ from 'lodash'; 
// import { SelfResitrationService } from '../../../registration/services/self-registration.service';
// import { EncDecService } from 'src/app/modules/shared/services/encryption-decryption.service';
import { MapsAPILoader } from '@agm/core';
import { AppointmentMapService } from '../../service/appointment-map.service';
import { AppointmentV2Service } from 'src/app/screens/appointment-table/services/appointment-v2.service';

declare var MapmyIndia: any;
declare var L: any;
// declare var allMarkers: any;
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit {
  
  @Output() foundCenters = new EventEmitter();
  @Output() centerSelected = new EventEmitter();
  searchPlace = '';
  centerList:any = [];
  centerSubscription:any;
  showMap=false;
  noCenterMsg=false;

  constructor(
    private appointmentV2: AppointmentV2Service,
    private utilsService: UtilsService,
    // private locationService: LocationService,
    private router: Router,
    // private encdecService:EncDecService,
    private mapService:AppointmentMapService,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
    ) { }


  // map variables
  allMarkers:any = [];
  infowindow:any;
  map:any;

  //agm
  latitude: number = 28.58;
  longitude: number = 77.23;
  private geoCoder:any;


  ngOnInit() {
    // this.selfRegService.setLoginMenu(true);
    this.mapService.load('mapload', 'mapsdk').then(data => {
      this.appointmentV2.seachTabChanged.subscribe(index => {
        if(index == undefined || index == null || index != 2)
          return;
      
      // console.log('script loaded ', data);
      this.loadMap();
          
      /*Search plugin initialization*/
      var optional_config={
          location:[28.61, 77.23],
          /* pod:'City',
          bridge:true,
          tokenizeAddress:true,*
          filter:'cop:9QGXAM',
          distance:true,
          width:300,
          height:300*/
      };
      new MapmyIndia.search(document.getElementById("searchPlace"),optional_config,(data:any) => { this.placeResult(data)});
        /*CALL for fix text - LIKE THIS
          * 
          new MapmyIndia.search("agra",optional_config,callback);
          * 
          * */
      // });
      })
    }).catch(error => console.error(error));
  }

  loadMap(){
    if(this.showMap == true) return;
    setTimeout(() => {
      this.map = new MapmyIndia.Map('mapdiv', {center: [28.09, 78.3], zoom: 5, maxZoom:17, search: false, clickableIcons:false});
      this.setCurrentLocation();
    }, 100);
    this.showMap = true;
  }

  placeResult(data:any):any { 
    if(data)
    {
        var dt=data[0];
        if(!dt) return false;
        setTimeout(() => {
          let elem:any =  document.getElementById('mmi_search_searchPlace');
          elem.style.display="none";
        }, 300);
        // console.log('done')
        var eloc=dt.eLoc;
        var place=dt.placeName+(dt.placeAddress?", "+dt.placeAddress:"");
         /*Use elocMarker Plugin to add marker*/
        //  if(this.allMarkers) this.allMarkers.remove();
        this.mapmyindia_removeMarker();
        var postion = new L.LatLng(dt.latitude, dt.longitude); 
        var mk = this.addMarker(postion, '', place, null);
        if(!this.allMarkers) this.allMarkers = [];
        this.allMarkers.push(mk);
        var group = new L.featureGroup(this.allMarkers);
        this.map.fitBounds(group.getBounds().pad(0.02),{maxZoom:17});
        //  this.allMarkers=new MapmyIndia.elocMarker({map:this.map,eloc:eloc,popupHtml:place,popupOptions:{openPopup:true}}).fitbounds();
        let location = data[0];
        // console.log(location) 
        this.latitude = Number.parseFloat(location.latitude.toFixed(2));
        this.longitude = Number.parseFloat(location.longitude.toFixed(2));
        this.getCentersByLatLong();
       
    }
  }  

  mapmyindia_removeMarker() {
    var markerlength = this.allMarkers.length;
    if (markerlength > 0) {
      for (var i = 0; i < markerlength; i++) {
        this.map.removeLayer(this.allMarkers[i]); /* deletion of marker object from the map */
      }
    }
    // delete marker;
    this.allMarkers = [];
    let ele:any = document.getElementById("event-log");
    if(ele)
    ele.innerHTML = "";
  }

  addMarker(position:any, icon:any, title:any, data:any) {
    /* position must be instance of L.LatLng that replaces current WGS position of this object. Will always return current WGS position.*/
    var event_div:any = document.getElementById("event-log");
    if (icon == '') {
      var mk = new L.Marker(position, {
        draggable: false,
        // title: title
        content:title
      }); /*marker with a default icon and optional param draggable, title */
      mk.bindPopup(title);
    } else {
      var mk = new L.Marker(position, {
        icon: icon,
        draggable: false,
        content:title
        // title: title
      }); /*marker with a custom icon */
      mk.bindPopup(title);
    }
    this.map.addLayer(mk); /*add the marker to the map*/
    /* marker events:*/
    let that = this;
    mk.on("click", function(e:any) {
      // if(event_div)
      // event_div.innerHTML = "Marker clicked<br>" + event_div.innerHTML;
      // console.log(e,data)
      if(data == undefined || data == null) return;
      that.centerSelected.emit(data);
      mk.closePopup();
    });
    mk.on("mouseover", function(e:any) {                  
      mk.openPopup();
      if(that.utilsService.isPresent(data) && that.utilsService.isPresent(data.center_id)) {
        document.getElementById(`center_id_${data.center_id}`)?.removeEventListener('click',() => {});
        document.getElementById(`center_id_${data.center_id}`)?.addEventListener('click',() => {mk.closePopup(); that.centerSelect(data)});
      } 
    }); 

    //auto close on mouse out
    // mk.on("mouseout", function(e:any) {                  
    //   mk.closePopup();   
    // }); 
  
    return mk;
  }

  // mapmyindia_fit_markers_into_bound() {
  //   var maxlat = Math.max.apply(null, latitudeArr);
  //   var maxlon = Math.max.apply(null, longitudeArr);
  //   var minlat = Math.min.apply(null, latitudeArr);
  //   var minlon = Math.min.apply(null, longitudeArr);
  //   var southWest = L.latLng(maxlat, maxlon); /*south-west WGS location object*/
  //   var northEast = L.latLng(minlat, minlon); /*north-east WGS location object*/
  //   var bounds = L.latLngBounds(southWest, northEast); /*This class represents bounds on the Earth sphere, defined by south-west and north-east corners*/
  //   map.fitBounds(bounds); /*Sets the center map position and level so that all markers is the area of the map that is displayed in the map area*/
  // }


  //find place from service
  getPlaces(){
    let place = this.searchPlace;
    // this.appointmentMapService.setLastMapLocation(this.searchPlace);
    const request = {
      query: place,
      fields: ["name", "geometry"],
    };
    this.clearAllMarks();
    let service = new google.maps.places.PlacesService(this.map);
    service.findPlaceFromQuery(request, (results:any, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && results) {
        
        if(results.length > 0 && this.utilsService.isPresent(results[0])){
          this.createMarker(results[0]);
          this.latitude = Number.parseFloat(results[0].geometry.location.lat().toFixed(2));
          this.longitude = Number.parseFloat(results[0].geometry.location.lng().toFixed(2));
          this.map.setCenter(results[0].geometry.location);
          
        }
        this.map.setZoom(18);
        this.getCentersByLatLong();
      }
    });

  }
  

  //create marker using google response from service
  createMarker(place:any) {
    if (!place.geometry || !place.geometry.location) return;
    const marker:any = new google.maps.Marker({
      map:this.map,
      position: place.geometry.location,
    });
    google.maps.event.addListener(marker, "click", () => {
      this.infowindow.setContent(place.name || "");
      this.infowindow.open(this.map);
    });
    // this.allMarkers.push(marker);
  }


  //ask users location and set in globle
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.latitude = Number.parseFloat(this.latitude.toFixed(2))
        this.longitude = Number.parseFloat(this.longitude.toFixed(2))
        // console.log(this.latitude,this.longitude);
        // this.createDefaultMarker(this.latitude,this.longitude,'Your Location');
        this.createDefaultMapMarker(this.latitude,this.longitude)
        this.getCentersByLatLong();
      },(err) => {
        console.log('error while get user location',err)
        // this.createDefaultMarker(this.latitude,this.longitude,'');
        this.createDefaultMapMarker(this.latitude,this.longitude)
        this.getCentersByLatLong();
      });
    }
  }

  createDefaultMapMarker(lat:any,long:any){
    var postion = new L.LatLng(lat, long); 
    var mk = this.addMarker(postion, '', 'Current Location', null);
    if(!this.allMarkers) this.allMarkers = [];
    this.allMarkers.push(mk);
    var group = new L.featureGroup(this.allMarkers);
    this.map.fitBounds(group.getBounds().pad(0.02),{maxZoom:17});
  }

  getCentersByLatLong(){
    this.centerList = [];
    this.noCenterMsg = false;
    if(this.centerSubscription){
      this.centerSubscription.unsubscribe();
    }
    this.centerSubscription = this.appointmentV2.getCentersByLatLong({lat:this.latitude.toFixed(2),long:this.longitude.toFixed(2)}).subscribe( res => {
      // console.log(res);
      if(res && this.utilsService.isPresent(res.centers) && res.centers.length > 0){
        res.centers.map((cen:any) => {
          if(this.utilsService.isPresent(cen)){
            // cen = JSON.parse(cen.replaceAll("'","\""))
            // console.log('parsed data',cen)
            this.centerList.push(cen);
          }
        });
        // this.centerList = res.centers;
        this.foundCenters.emit({centers :this.centerList});
        this.markLocations();
      }else{
        this.noCenterMsg = true;
      }
    })
  }

  markLocations() {
    
    var marker, i;
    // let infowindowlocal = new google.maps.InfoWindow();

    // var icons = {
    //   url: "./assets/images/cowin-map-marker.png", // url
    //   scaledSize: new google.maps.Size(35, 35)
    // };
    var icon = L.icon({
      iconUrl: './assets/images/cowin-map-marker.png',
      iconRetinaUrl: './assets/images/cowin-map-marker.png',
      iconSize: [30, 30],
      popupAnchor: [-3, -15]
    });
    for (i = 0; i < this.centerList.length; i++) {
        let centerObj = this.centerList[i];
        let centerDetails = centerObj;
        let addressString = '';
        if(this.utilsService.isPresent(centerDetails.location)) addressString+= centerDetails.location + ', ';
        if(this.utilsService.isPresent(centerDetails.district_name)) addressString+= centerDetails.district_name +', ';
        if(this.utilsService.isPresent(centerDetails.state_name)) addressString+= centerDetails.state_name + ', ';
        if(this.utilsService.isPresent(centerDetails.pincode)) addressString+= centerObj.pincode + '.';
  
        let bodycontent = `<div class='map_info_wrapper' style="padding:0;color:#002060;font-weight:500;min-height:50px;font-family: 'Montserrat', sans-serif;flex-direction:column;text-align:left;" >
        <h5 style="font-size:14px;font-weight:500;text-align:left;margin:0;">${centerDetails.name}</h5>
        <p style="font-size:12px;text-align:left;font-weight:400;margin:0px 0;color:#999; padding-bottom:7px">${addressString}</p>
        <a style="cursor:pointer;display:flex;justify-content:flex-end;" id="center_id_${centerObj.center_id}">Check Availability</a>
        </div>`;
        var postion = new L.LatLng(centerObj.lat, centerObj.long); /*WGS location object*/
        var mk = this.addMarker(postion, icon, bodycontent, centerObj);
        if(!this.allMarkers) this.allMarkers = [];
        this.allMarkers.push(mk);
        // this.map.setView(mk.getLatLng());
    }
    var group = new L.featureGroup(this.allMarkers);
    this.map.fitBounds(group.getBounds().pad(0.02),{maxZoom:17});
    // this.map.fitBounds(group.getBounds());

    // var bounds:any = new google.maps.LatLngBounds();
    // for (i = 0; i < this.centerList.length; i++) {
    //   let centerObj = this.centerList[i];
    //   let centerDetails = centerObj;
    //   let addressString = '';
    //   if(this.utilsService.isPresent(centerDetails.block_name)) addressString+= centerDetails.block_name + ', ';
    //   if(this.utilsService.isPresent(centerDetails.district_name)) addressString+= centerDetails.district_name +', ';
    //   if(this.utilsService.isPresent(centerDetails.state_name)) addressString+= centerDetails.state_name + ', ';
    //   if(this.utilsService.isPresent(centerDetails.pincode)) addressString+= centerObj.pincode + '.';

    //   let bodycontent = `<div class='map_info_wrapper' style="color:#002060;font-weight:500;height:60px;width:300px;font-family: 'Montserrat', sans-serif;flex-direction:column;text-align:left;" >
    //   <h5 style="font-size:16px;text-align:left;margin:0;">${centerDetails.name}</h5>
    //   <p style="font-size:14px;text-align:left;font-weight:400;margin:5px 0;">${addressString}</p>
      
    //   </div>`;

    //   // <p style="color:#00ff00;font-size:14px;font-weight:600;margin:5px 0;">Free</p>
    //   // <p style="color:#525252;font-size:14px;font-weight:600;margin:5px 0;">Paid</p>
  
    //   marker = new google.maps.Marker({
    //     position: new google.maps.LatLng(centerObj.lat, centerObj.long),
    //     icon: icons,
    //     optimized: false,
    //     map: this.map
    //   });
    //   bounds.extend(marker.getPosition());
    //   this.map.fitBounds(bounds);
    //   // let isClicked = false;
    //   let that = this; 
    //   google.maps.event.addListener(marker, 'click', (function (marker, bodycontent,centerDetails) {
    //     // isClicked = true;
        
    //     return function () {
    //       that.centerSelected.emit(centerDetails)
    //       infowindowlocal.setContent(bodycontent);
    //       infowindowlocal.open(that.map, marker);
    //     }
    //   })(marker,bodycontent,centerDetails))
    //   google.maps.event.addListener(marker, 'mouseover',(function(marker,bodycontent) {
    //     // console.log('hover',that.centerList[i])
    //     // if(!isClicked) {
    //       return function(){
    //       infowindowlocal.setContent(bodycontent);
    //       infowindowlocal.open(that.map, marker);
    //       }
    //     // }
    //   })(marker,bodycontent));
    //   // this.allMarkers.push(marker)
    
    // }
  }

  centerSelect(data:any){
    // console.log(center_id)
    if(this.utilsService.isPresent(data))
      this.centerSelected.emit(data)
  }

  // create default marker
  createDefaultMarker(lat:any, long:any, infoText:any){
    this.clearAllMarks();
    var marker:any, i;
    let infowindowlocal = new google.maps.InfoWindow();

    // var icons = {
    //   url: "spl.png", // url
    //   scaledSize: new google.maps.Size(20, 20)
    // };
    let that = this
    var bounds = new google.maps.LatLngBounds();
    marker = new google.maps.Marker({
      position: new google.maps.LatLng(lat,long),
      // icon: icons,
      map: this.map
    });
    bounds.extend(marker.getPosition());
      this.map.fitBounds(bounds);
      google.maps.event.addListener(marker, 'click', (function (marker, i) {
        return function () {
          infowindowlocal.setContent(infoText);
          infowindowlocal.open(that.map, marker);
        }
      })(marker, i));
      // this.allMarkers.push(marker);
  }

  //clear markers
  clearAllMarks(){
    // for (let i = 0; i < this.allMarkers.length; i++) {
    //   this.allMarkers[i].setMap(null);
    // }
    // this.allMarkers = [];
  }


}
